import './WelcomeVideo.sass';

import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Block } from '$uikit';
import { useCurrentUserInfo, useTranslator, useVisibleElement } from '$hooks';
import { IcAngleUp16, IcEdit28 } from '$assets';
import { InlineVideo } from '$shared/components';
import { getImageSizeByUrl, classNames as cn } from '$utils';
import { profileActions, profileInfoSelector, profileSelector } from '$store/profile';
import { WelcomeVideoProps } from '$core/Profile/WelcomeVideo/WelcomeVideo.interface';

export const WelcomeVideo: FC<WelcomeVideoProps> = ({ video, profileId }) => {
  const user = useCurrentUserInfo();
  const canEdit = profileId === user.id;
  const t = useTranslator();
  const contentRef = useRef<HTMLDivElement>(null);
  const { visible } = useVisibleElement(contentRef, true);
  const dispatch = useDispatch();
  const { skipWelcomeVideoProfiles, welcomeVideoEdit } = useSelector(profileSelector);
  const hidden = skipWelcomeVideoProfiles.includes(profileId);

  const handleIconClick = useCallback(() => {
    if (canEdit) {
      dispatch(profileActions.setWelcomeVideoEdit(true));
    } else if (hidden) {
      dispatch(profileActions.removeSkipWelcomeVideoProfiles(profileId));
    } else {
      dispatch(profileActions.addSkipWelcomeVideoProfiles(profileId));
    }
  }, [canEdit, hidden]);

  return (
    <Block className="WelcomeVideo">
      <div className="WelcomeVideo__header" onClick={handleIconClick}>
        <div className="WelcomeVideo__title">{t('welcome_video_create_title')}</div>
        <div className={cn('WelcomeVideo__iconButton', { hidden })}>
          {canEdit ? <IcEdit28 /> : <IcAngleUp16 />}
        </div>
      </div>
      {!hidden && (
        <div ref={contentRef} className="WelcomeVideo__content">
          <InlineVideo
            video={video}
            parentObject={''}
            decryptKey={''}
            isHidden={false}
            isBlocked={false}
            isVisible={visible}
          />
        </div>
      )}
    </Block>
  );
};
